/* Wishes Made Easy - PDP state machine (v3)
   All taps, zero typing. State: crew / occasion / tier / bumps.
   Config is server-rendered into #wme-pdp-config by sections/wme-pdp.liquid. */
(function () {
  'use strict';

  var root = document.querySelector('[data-wme-pdp]');
  if (!root) return;
  var cfgEl = document.getElementById('wme-pdp-config');
  if (!cfgEl) return;

  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var crews = CFG.crews || [];
  var occasions = CFG.occasions || [];
  var bumps = CFG.bumps || [];
  var works = CFG.works || null;
  var CURRENCY = CFG.currency || 'GBP';
  var LOCALE = CFG.locale || 'en-GB';

  var nf;
  try {
    nf = new Intl.NumberFormat(LOCALE, { style: 'currency', currency: CURRENCY, minimumFractionDigits: 2 });
  } catch (e) { nf = null; }
  function money(pennies) {
    if (nf) return nf.format(pennies / 100);
    return '£' + (pennies / 100).toFixed(2);
  }

  var S = { crew: 0, occ: 0, tier: 1, bumps: [false, false, false, false, false] };

  function clampInt(v, min, max, dflt) {
    var n = parseInt(v, 10);
    if (isNaN(n) || n < min || n > max) return dflt;
    return n;
  }

  function readUrl() {
    var q;
    try { q = new URLSearchParams(window.location.search); } catch (e) { q = null; }
    if (CFG.defaultCrew != null) S.crew = clampInt(CFG.defaultCrew, 0, crews.length - 1, S.crew);
    if (CFG.defaultOcc != null) S.occ = clampInt(CFG.defaultOcc, 0, occasions.length - 1, S.occ);
    if (!q) return;
    if (q.has('crew')) S.crew = clampInt(q.get('crew'), 0, crews.length - 1, S.crew);
    if (q.has('occ')) S.occ = clampInt(q.get('occ'), 0, occasions.length - 1, S.occ);
    if (q.has('tier')) S.tier = clampInt(q.get('tier'), 0, 2, S.tier);
    if (q.has('bumps')) {
      var b = String(q.get('bumps'));
      for (var i = 0; i < 5; i++) S.bumps[i] = b.charAt(i) === '1';
    }
  }

  function writeUrl() {
    if (!window.history || !window.history.replaceState) return;
    var q;
    try { q = new URLSearchParams(window.location.search); } catch (e) { return; }
    q.set('crew', S.crew); q.set('occ', S.occ); q.set('tier', S.tier);
    q.set('bumps', S.bumps.map(function (x) { return x ? '1' : '0'; }).join(''));
    window.history.replaceState(null, '', window.location.pathname + '?' + q.toString());
  }

  function crew() { return crews[S.crew] || crews[0] || { name: '', tiers: [] }; }
  function tierOf(c, i) { return (c && c.tiers && c.tiers[i]) || null; }

  function secondPrice() {
    var b = bumps[4];
    return (b && b.price != null) ? b.price : 2500;
  }
  function bumpPrice(i) {
    var b = bumps[i];
    return (b && b.price != null) ? b.price : 0;
  }
  function bumpActive(i) {
    var b = bumps[i];
    return !!(b && b.variantId);
  }
  function allFour() {
    for (var i = 0; i < 4; i++) { if (!bumpActive(i) || !S.bumps[i]) return false; }
    return true;
  }
  function worksPrice() { return (works && works.price != null) ? works.price : 1999; }

  function compute() {
    var c = crew();
    var t = tierOf(c, S.tier) || tierOf(c, 0) || { price: 0, compareAt: 0 };
    var base = tierOf(c, 0) || t;
    /* the 2nd-video saving is quoted against the cheapest crew's entry price,
       never the premium crew's - understating a saving is safe, overstating is not */
    var flagship = tierOf(crews[0], 0) || base;

    var four = allFour() && !!works;
    var extras = 0;
    for (var i = 0; i < 4; i++) {
      if (!S.bumps[i] || !bumpActive(i)) continue;
      if (i === 3 && S.bumps[4] && bumpActive(4)) continue;
      extras += bumpPrice(i);
    }
    if (four) extras = worksPrice();

    var second = (S.bumps[4] && bumpActive(4)) ? secondPrice() : 0;
    var total = t.price + extras + second;

    var save = 0;
    if (t.compareAt && t.compareAt > t.price) save += (t.compareAt - t.price);
    if (second) save += Math.max(0, flagship.price - secondPrice());
    if (four) {
      var listed = 0;
      for (var j = 0; j < 4; j++) listed += bumpPrice(j);
      save += Math.max(0, listed - worksPrice());
    } else if (S.bumps[4] && bumpActive(4) && S.bumps[3] && bumpActive(3)) {
      save += bumpPrice(3);
    }

    return { crew: c, tier: t, base: base, total: total, save: save, four: four };
  }

  function londonParts(d) {
    try {
      var f = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London', hour12: false,
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      });
      var o = {};
      f.formatToParts(d).forEach(function (p) { o[p.type] = p.value; });
      return o;
    } catch (e) { return null; }
  }

  function cutoffMs() {
    var p = londonParts(new Date());
    if (!p) return null;
    var secsNow = parseInt(p.hour, 10) * 3600 + parseInt(p.minute, 10) * 60 + parseInt(p.second, 10);
    var diff = (14 * 3600) - secsNow;
    if (diff <= 0) diff += 24 * 3600;
    return diff * 1000;
  }

  function deliverByLabel() {
    var now = new Date();
    var p = londonParts(now);
    if (!p) return 'tomorrow, 2pm';
    if (parseInt(p.hour, 10) < 14) return 'tomorrow, 2pm';
    var d = new Date(now.getTime() + 2 * 86400000);
    try {
      return new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', weekday: 'long' }).format(d) + ', 2pm';
    } catch (e) { return 'in 48 hours'; }
  }

  function startClock() {
    var els = document.querySelectorAll('[data-wme-clock]');
    if (!els.length) return;
    function tick() {
      var ms = cutoffMs();
      if (ms == null) return;
      var total = Math.floor(ms / 1000);
      var hrs = Math.floor(total / 3600);
      var min = Math.floor((total % 3600) / 60);
      var txt = hrs + 'h ' + (min < 10 ? '0' : '') + min + 'm left';
      for (var i = 0; i < els.length; i++) els[i].textContent = txt;
    }
    tick();
    setInterval(tick, 30000);
  }

  function setText(sel, txt) {
    var els = root.querySelectorAll(sel);
    for (var i = 0; i < els.length; i++) els[i].textContent = txt;
  }

  function render() {
    var d = compute();
    var c = d.crew;
    var occ = occasions[S.occ] || occasions[0] || { word: 'celebration', plain: '' };

    setText('[data-wme-h1]', 'A personalised ' + occ.word + ' video from ' + c.name);

    var heroImgs = root.querySelectorAll('[data-wme-hero-img]');
    for (var i = 0; i < heroImgs.length; i++) {
      if (heroImgs[i].getAttribute('src') !== c.image) heroImgs[i].setAttribute('src', c.image);
      heroImgs[i].setAttribute('alt', c.name + ' performing a personalised ' + occ.word + ' video greeting');
    }
    /* Only the flagship crew has a hero video. For the rest the video element is
       hidden and a still is shown — but it kept its source, so the play button
       unmuted and played the WRONG crew's audio underneath a correct still.
       Pause and mute it, and hide the affordances that promise a sample. */
    var wantVideo = !!c.video;
    var heroVids = root.querySelectorAll('[data-wme-hero-video]');
    for (var v = 0; v < heroVids.length; v++) {
      if (!wantVideo) { try { heroVids[v].pause(); } catch (e) {} heroVids[v].muted = true; }
      heroVids[v].hidden = !wantVideo;
    }
    var playBtns = root.querySelectorAll('[data-wme-play]');
    for (var pb = 0; pb < playBtns.length; pb++) playBtns[pb].hidden = !wantVideo;
    var sampleTags = root.querySelectorAll('[data-wme-sampletag]');
    for (var st = 0; st < sampleTags.length; st++) sampleTags[st].hidden = !wantVideo;
    var expressLabels = root.querySelectorAll('[data-wme-expresslabel]');
    for (var xl = 0; xl < expressLabels.length; xl++) {
      expressLabels[xl].textContent = c.name + ' · Premium · inbox in 24h';
    }
    var crewThumbs = root.querySelectorAll('[data-wme-thumb-crew]');
    for (var ct = 0; ct < crewThumbs.length; ct++) {
      crewThumbs[ct].setAttribute('src', c.image.replace('width=900', 'width=400'));
      crewThumbs[ct].setAttribute('alt', c.name + ' performing a personalised video greeting');
    }
    var heroWraps = root.querySelectorAll('[data-wme-hero-imgwrap]');
    for (var w = 0; w < heroWraps.length; w++) heroWraps[w].hidden = wantVideo;

    setText('[data-wme-crewname]', c.name);

    var noteEls = root.querySelectorAll('[data-wme-crewnote]');
    for (var n = 0; n < noteEls.length; n++) noteEls[n].textContent = c.note || '';

    var cbs = root.querySelectorAll('[data-wme-crew]');
    for (var cb = 0; cb < cbs.length; cb++) {
      cbs[cb].setAttribute('aria-pressed', String(parseInt(cbs[cb].getAttribute('data-wme-crew'), 10) === S.crew));
    }
    var obs = root.querySelectorAll('[data-wme-occ]');
    for (var ob = 0; ob < obs.length; ob++) {
      obs[ob].setAttribute('aria-pressed', String(parseInt(obs[ob].getAttribute('data-wme-occ'), 10) === S.occ));
    }

    setText('[data-wme-from]', 'From ' + money(d.base.price));
    var fromWas = root.querySelectorAll('[data-wme-fromwas]');
    for (var fw = 0; fw < fromWas.length; fw++) {
      if (d.base.compareAt && d.base.compareAt > d.base.price) {
        fromWas[fw].textContent = money(d.base.compareAt);
        fromWas[fw].hidden = false;
      } else { fromWas[fw].hidden = true; }
    }

    var pbs = root.querySelectorAll('[data-wme-tier]');
    for (var pb = 0; pb < pbs.length; pb++) {
      var idx = parseInt(pbs[pb].getAttribute('data-wme-tier'), 10);
      var tv = tierOf(c, idx);
      pbs[pb].setAttribute('aria-pressed', String(idx === S.tier));
      pbs[pb].hidden = !tv;
      if (!tv) continue;
      var prEl = pbs[pb].querySelector('[data-wme-tier-price]');
      var wasEl = pbs[pb].querySelector('[data-wme-tier-was]');
      var pctEl = pbs[pb].querySelector('[data-wme-tier-pct]');
      if (prEl) prEl.textContent = money(tv.price);
      if (wasEl) {
        if (tv.compareAt && tv.compareAt > tv.price) { wasEl.textContent = money(tv.compareAt); wasEl.hidden = false; }
        else wasEl.hidden = true;
      }
      if (pctEl) {
        if (tv.compareAt && tv.compareAt > tv.price) {
          pctEl.textContent = '−' + Math.round((1 - tv.price / tv.compareAt) * 100) + '%';
          pctEl.hidden = false;
        } else pctEl.hidden = true;
      }
    }

    var vip = tierOf(c, 2);
    var cur = tierOf(c, S.tier);
    var nud = root.querySelector('[data-wme-nudge]');
    if (nud) {
      var showN = S.tier < 2 && !!vip && !!cur && vip.price > cur.price;
      nud.hidden = !showN;
      if (showN) {
        var tt = nud.querySelector('[data-wme-nudge-title]');
        if (tt) tt.textContent = 'Upgrade to VIP — just ' + money(vip.price - cur.price) + ' more';
      }
    }

    var wbtn = root.querySelector('[data-wme-works]');
    if (wbtn) {
      var canWorks = !!works;
      for (var k = 0; k < 4; k++) if (!bumpActive(k)) canWorks = false;
      wbtn.hidden = !canWorks;
      wbtn.setAttribute('aria-pressed', String(d.four));
      var listedAll = bumpPrice(0) + bumpPrice(1) + bumpPrice(2) + bumpPrice(3);
      var wt = wbtn.querySelector('[data-wme-works-title]');
      if (wt) wt.textContent = d.four ? 'The Works added ✓ — bundle price' : 'The Works — save ' + money(Math.max(0, listedAll - worksPrice()));
      var wp = wbtn.querySelector('[data-wme-works-price]');
      if (wp) wp.textContent = money(worksPrice());
      var ww = wbtn.querySelector('[data-wme-works-was]');
      if (ww) ww.textContent = money(listedAll);
    }

    var bbs = root.querySelectorAll('[data-wme-bump]');
    for (var bb = 0; bb < bbs.length; bb++) {
      var bi = parseInt(bbs[bb].getAttribute('data-wme-bump'), 10);
      var el = bbs[bb];
      el.hidden = !bumpActive(bi);
      if (!bumpActive(bi)) continue;
      var freeCut = (bi === 3 && S.bumps[4] && bumpActive(4));
      el.setAttribute('aria-pressed', String(!!S.bumps[bi]));
      el.classList.toggle('is-free', freeCut && !S.bumps[bi]);
      var pEl = el.querySelector('[data-wme-bump-price]');
      if (pEl) pEl.textContent = freeCut ? (S.bumps[bi] ? 'FREE ✓' : 'FREE') : '+' + money(bumpPrice(bi));
      var dEl = el.querySelector('[data-wme-bump-desc]');
      if (dEl) dEl.textContent = freeCut ? 'Unlocked FREE with your 2nd video' : (bumps[bi].desc || '');
      var box = el.querySelector('[data-wme-bump-box]');
      if (box) box.textContent = S.bumps[bi] ? '✓' : '';
    }

    setText('[data-wme-total]', money(d.total));
    setText('[data-wme-save]', d.save > 0 ? "you're saving " + money(d.save) : '');
    setText('[data-wme-delivery]', S.tier === 0 ? 'arrives in 48-72h' : 'in their inbox within 24h');
    setText('[data-wme-deliverby]', deliverByLabel());

    writeUrl();
  }

  function buildItems() {
    var d = compute();
    var c = d.crew;
    var occ = occasions[S.occ] || {};
    var t = tierOf(c, S.tier);
    if (!t || !t.variantId) return null;

    var props = {
      'Crew': c.name,
      'Occasion': occ.plain || occ.word || '',
      'Package': ['Basic', 'Premium', 'VIP'][S.tier] || '',
      '_wme_state': 'crew=' + S.crew + '&occ=' + S.occ + '&tier=' + S.tier + '&bumps=' + S.bumps.map(function (x) { return x ? '1' : '0'; }).join(''),
      '_wme_details': 'pending'
    };

    var items = [{ id: t.variantId, quantity: 1, properties: props }];

    if (d.four && works && works.variantId) {
      items.push({ id: works.variantId, quantity: 1, properties: { 'Applies to': c.name } });
    } else {
      for (var i = 0; i < 4; i++) {
        if (!S.bumps[i] || !bumpActive(i)) continue;
        if (i === 3 && S.bumps[4] && bumpActive(4)) continue;
        items.push({ id: bumps[i].variantId, quantity: 1, properties: { 'Applies to': c.name } });
      }
    }
    if (S.bumps[4] && bumpActive(4)) {
      items.push({ id: bumps[4].variantId, quantity: 1, properties: { 'Applies to': c.name, 'Includes': 'Vertical cut FREE' } });
    }
    return items;
  }

  function addToCart(goToCheckout) {
    var items = buildItems();
    var btn = root.querySelector('[data-wme-checkout]');
    if (!items) {
      if (btn) btn.textContent = 'Unavailable - pick another crew';
      return;
    }
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.dataset.label = btn.textContent; btn.textContent = 'Adding...'; }

    fetch(CFG.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        if (window.dataLayer) window.dataLayer.push({ event: 'add_to_cart', wme_crew: crew().name, wme_tier: S.tier });
        window.location.href = goToCheckout ? CFG.routes.checkout : CFG.routes.cart;
      }).catch(function () {
        if (btn) { btn.removeAttribute('aria-disabled'); btn.textContent = btn.dataset.label || 'Checkout'; }
        window.location.href = CFG.routes.cart;
      });
  }

  root.addEventListener('click', function (e) {
    var el;
    if ((el = e.target.closest('[data-wme-crew]'))) {
      S.crew = parseInt(el.getAttribute('data-wme-crew'), 10);
      if (!tierOf(crew(), S.tier)) S.tier = 1;
      render(); return;
    }
    if ((el = e.target.closest('[data-wme-occ]'))) { S.occ = parseInt(el.getAttribute('data-wme-occ'), 10); render(); return; }
    if ((el = e.target.closest('[data-wme-tier]'))) { S.tier = parseInt(el.getAttribute('data-wme-tier'), 10); render(); return; }
    if ((el = e.target.closest('[data-wme-bump]'))) {
      var i = parseInt(el.getAttribute('data-wme-bump'), 10);
      S.bumps[i] = !S.bumps[i];
      render(); return;
    }
    if (e.target.closest('[data-wme-works]')) {
      var on = !allFour();
      for (var k = 0; k < 4; k++) if (bumpActive(k)) S.bumps[k] = on;
      render(); return;
    }
    if (e.target.closest('[data-wme-nudge]')) { S.tier = 2; render(); return; }
    if (e.target.closest('[data-wme-checkout]')) { e.preventDefault(); addToCart(true); return; }
    if (e.target.closest('[data-wme-express]')) {
      e.preventDefault();
      S.tier = 1; S.bumps = [false, false, false, false, false];
      render(); addToCart(true); return;
    }
    if ((el = e.target.closest('[data-wme-play]'))) {
      var vv = root.querySelector('[data-wme-hero-video]');
      if (vv && !vv.hidden) {
        vv.muted = false;
        var playReq = vv.play();
        if (playReq && playReq.then) {
          playReq.then(function () { el.hidden = true; }).catch(function () {
            vv.muted = true; vv.defaultMuted = true;
            var retry = vv.play(); if (retry && retry.catch) retry.catch(function () { });
          });
        } else { el.hidden = true; }
      }
      return;
    }
  });

  function playAll() {
    var vids = root.querySelectorAll('video[data-wme-hero-video]');
    for (var i = 0; i < vids.length; i++) {
      if (vids[i].hidden) continue;
      vids[i].muted = true; vids[i].defaultMuted = true;
      if (vids[i].paused) vids[i].play().catch(function () { });
    }
  }

  function swapToStill() {
    var hvids = root.querySelectorAll('video[data-wme-hero-video]');
    for (var hv = 0; hv < hvids.length; hv++) hvids[hv].hidden = true;
    var wraps = root.querySelectorAll('[data-wme-hero-imgwrap]');
    for (var wr = 0; wr < wraps.length; wr++) wraps[wr].hidden = false;
    var pbtns = root.querySelectorAll('[data-wme-play]');
    for (var pb2 = 0; pb2 < pbtns.length; pb2++) pbtns[pb2].hidden = true;
    var stags = root.querySelectorAll('[data-wme-sampletag]');
    for (var tg = 0; tg < stags.length; tg++) stags[tg].hidden = true;
  }
  (function () {
    var heroVid = root.querySelector('[data-wme-hero-video]');
    if (!heroVid) return;
    heroVid.addEventListener('error', swapToStill);
    var heroSrc = heroVid.querySelector('source');
    if (heroSrc) heroSrc.addEventListener('error', swapToStill);
    if (heroVid.error) swapToStill();
  })();

  readUrl();
  render();
  startClock();
  playAll();
  document.addEventListener('visibilitychange', function () { if (!document.hidden) playAll(); });
})();
